<div class="h-[60vh] w-[60vw] text-3xl">
  <div class="grid grid-cols-4 grid-rows-12 pl-7 gap-2">
    <div class="col-start-1 row-start-1">
      {{"PetDetails.Nickname"|translate}}
    </div>
    <div class="col-start-2 row-start-1">
      {{pet.nickname}}
    </div>
    <div class="col-start-3 row-start-1">
      {{"PetDetails.Gender"|translate}}
    </div>
    <div class="col-start-4 row-start-1">
      {{`PetDetails.Gender.${pet.gender}`|translate}}
    </div>
    <div class="col-start-1 row-start-2">
      {{"PetDetails.Race"|translate}}
    </div>
    <div class="col-start-2 row-start-2">
      {{pet.race}}
    </div>
    <div class="col-start-3 row-start-2">
      {{"PetDetails.NeuteringStatus"|translate}}
    </div>
    <div class="col-start-4 row-start-2">
      {{`Pet.NeuteringStatus.${pet.neuteringStatus}`|translate}}
    </div>
    <div class="col-start-1 row-start-3">
      {{"PetDetails.Age"|translate}}
    </div>
    <div class="col-start-2 row-start-3">
      {{getAge(pet.dateOfBirth)}}
    </div>
    <div class="col-start-3 row-start-3">
      {{"PetDetails.Color"|translate}}
    </div>
    <div class="col-start-4 row-start-3">
      {{pet.color}}
    </div>
    <div class="col-start-1 row-start-4">
      {{"PetDetails.ChipNumber"|translate}}
    </div>
    <div class="col-start-2 row-start-4">
      {{pet.chipNumber}}
    </div>
    <div class="col-start-3 row-start-4">
      {{"PetDetails.Species"|translate}}
    </div>
    <div class="col-start-4 row-start-4">
      {{`Pet.Species.${pet.species}`|translate}}
    </div>
    <div class="col-start-1 row-start-7">
      {{"Pet.FirstTreatmentDate"|translate}}
    </div>
    <div class="col-start-2 row-start-7">
      {{getDate(pet.firstTreatmentDate)}}
    </div>
    <div class="col-start-1 row-start-10">
      {{"PetDetails.IsInsured"|translate}}
    </div>
    <div class="col-start-2 row-start-10">
      {{(pet.isInsured?"Yes":"No")|translate}}
    </div>
    <div class="col-start-3 row-start-10">
      {{pet.insuranceProvider}}
    </div>
    <div class="col-start-4 row-start-10">
      {{pet.insuranceNumber}}
    </div>
    <div class="col-start-1 row-start-11">
      {{"PetDetails.HasHomeVet"|translate}}
    </div>
    <div class="col-start-2 row-start-11">
      {{pet.hasHomeVet?"Yes":"No"|translate}}
    </div>
    <div class="col-start-3 row-start-11">
      {{pet.homeVet?.name}}
    </div>
    <div class="col-start-4 row-start-11">
      {{pet.homeVet?.phoneNumber}}
    </div>
    <div class="col-start-1 row-start-12">
      {{"PetDetails.HasBreederGivenName"|translate}}
    </div>
    <div class="col-start-2 row-start-12">
      {{pet.hasBreederGivenName?"Yes":"No"|translate}}
    </div>
    <div class="col-start-3 row-start-12">
      {{pet.breederGivenName}}
    </div>
  </div>
</div>
